var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 4C2.3999 3.78782 2.48419 3.58434 2.63422 3.43431C2.78425 3.28428 2.98773 3.2 3.1999 3.2H12.7999C13.0121 3.2 13.2156 3.28428 13.3656 3.43431C13.5156 3.58434 13.5999 3.78782 13.5999 4C13.5999 4.21217 13.5156 4.41565 13.3656 4.56568C13.2156 4.71571 13.0121 4.8 12.7999 4.8H3.1999C2.98773 4.8 2.78425 4.71571 2.63422 4.56568C2.48419 4.41565 2.3999 4.21217 2.3999 4ZM2.3999 8C2.3999 7.78782 2.48419 7.58434 2.63422 7.43431C2.78425 7.28428 2.98773 7.2 3.1999 7.2H12.7999C13.0121 7.2 13.2156 7.28428 13.3656 7.43431C13.5156 7.58434 13.5999 7.78782 13.5999 8C13.5999 8.21217 13.5156 8.41565 13.3656 8.56568C13.2156 8.71571 13.0121 8.8 12.7999 8.8H3.1999C2.98773 8.8 2.78425 8.71571 2.63422 8.56568C2.48419 8.41565 2.3999 8.21217 2.3999 8ZM7.1999 12C7.1999 11.7878 7.28419 11.5843 7.43422 11.4343C7.58425 11.2843 7.78773 11.2 7.9999 11.2H12.7999C13.0121 11.2 13.2156 11.2843 13.3656 11.4343C13.5156 11.5843 13.5999 11.7878 13.5999 12C13.5999 12.2122 13.5156 12.4157 13.3656 12.5657C13.2156 12.7157 13.0121 12.8 12.7999 12.8H7.9999C7.78773 12.8 7.58425 12.7157 7.43422 12.5657C7.28419 12.4157 7.1999 12.2122 7.1999 12Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAlt3);
export default __webpack_public_path__ + "static/media/MenuAlt3.edb907a146a47fcdb562b9821115cbec.svg";
export { ForwardRef as ReactComponent };